import { render, staticRenderFns } from "./WeddingGift.vue?vue&type=template&id=69836166&scoped=true"
import script from "./WeddingGift.vue?vue&type=script&lang=js"
export * from "./WeddingGift.vue?vue&type=script&lang=js"
import style0 from "./WeddingGift.vue?vue&type=style&index=0&id=69836166&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69836166",
  null
  
)

export default component.exports